var isWeb = typeof window !== 'undefined' && typeof document !== 'undefined';
typeof wx !== 'undefined' && typeof wx.getSystemInfo === 'function';

/**
 * 全局无侵入点击埋点事件
 * @param e
 */
var createWebGlobalClickHandler = function createWebGlobalClickHandler(callback, options) {
  var clickEventAttr = options.clickEventAttr,
    clickEventBubble = options.clickEventBubble,
    clickEventCode = options.clickEventCode;
  var eventHandler = function eventHandler(e) {
    var target = e.target;
    while (target && target !== document) {
      var getAttribute = target.getAttribute.bind(target);
      var _info = getAttribute(clickEventAttr);
      var code = getAttribute(clickEventCode);
      if (code) {
        try {
          var info = _info ? JSON.parse(_info) : {};
          var event = {
            event_type_code: code,
            event_properties: info
          };
          callback(event);
        } catch (e) {
          throw '解析错误';
        }
        // 如果设置了 data-track-bubble = true 则继续向上递归寻找 data-track
        // 没有设置，则中止
        if (getAttribute(clickEventBubble) !== 'true') break;
      }
      target = target.parentNode;
      // 如果父节点为空则跳出
      if (!target) break;
    }
  };
  return eventHandler;
};

// import { ITrackPluginConstructor } from './base';
var clickPlugin = function clickPlugin(options) {
  return function (plugin) {
    // 原生事件回调
    // init： addEventListener
    // destroy: removeEventListener
    var eventHandler = createWebGlobalClickHandler(function (data) {
      plugin.track(data, {});
    }, options);
    var clickPluginConfig = {
      name: 'web-global-click',
      init: function init() {
        if (!isWeb) return;
        document.addEventListener('click', eventHandler);
      },
      // beforePluginSend: (data: any) => {
      //   return { ...data, pluginName: plugin.name };
      // },
      destroy: function destroy() {
        // console.log('插件destroy');
        if (!isWeb) return;
        document.removeEventListener('click', eventHandler);
      }
    };
    return clickPluginConfig;
  };
};

export { clickPlugin as default };
